import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import moduleSlice from "./slice/moduleSlice";

import {
  authServerApi,
  locationServerApi,
  specialtiesServerApi,
  moduleServerApi,
} from "./services";

export const store = configureStore({
  reducer: {
    moduleSlice,
    [authServerApi.reducerPath]: authServerApi.reducer,
    [locationServerApi.reducerPath]: locationServerApi.reducer,
    [specialtiesServerApi.reducerPath]: specialtiesServerApi.reducer,
    [moduleServerApi.reducerPath]: moduleServerApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authServerApi.middleware,
      locationServerApi.middleware,
      specialtiesServerApi.middleware,
      moduleServerApi.middleware
    ),
});

setupListeners(store.dispatch);
